import { is } from 'ramda'
import type { CustomEventsContext } from '../types'

export const LOCATION_ACCESS_DECLINED = 'Location Access Declined'

export default function (this: CustomEventsContext) {
  return this.sendEventWithCallback('location.request', {})
    .then((data: unknown) => {
      const d = data as { location?: unknown }
      if (is(Object, d.location)) {
        return data
      }
      return Promise.reject(new Error(
        (d.location === null)
          ? LOCATION_ACCESS_DECLINED
          : this.ERROR_UNKNOWN
      ))
    })
}
